var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-sm-row align-center pa-6 my-10",class:{'pa-sm-0' : !_vm.slice.padding},style:({
    'background-color': _vm.slice.background_color,
    'color': _vm.slice.text_color
  })},[(_vm.slice && _vm.slice.primary)?_c('youtube-embed',{staticClass:"video-player",attrs:{"url":_vm.sliceURL}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }